<script setup lang="ts">
import { AppLayout } from '@collector/shared-ui'
import Empty from '@desktop/views/Empty.vue'
import Content from '@desktop/views/Relation/Sports/components/RelationView/Content.vue'

import { useDynamicRoutes } from '../../composables'
import { DynamicRouteComponents } from '../../types'
import RelationViewHeader from './Header/RelationViewHeader.vue'

const { relation, statistics } = defineProps<Partial<DynamicRouteComponents>>()

// composables
const { initRoutes } = useDynamicRoutes()

// init
initRoutes({
  relation: relation ?? Content,
  statistics: statistics ?? Empty,
})
</script>

<template>
  <AppLayout>
    <template #header>
      <RelationViewHeader />
    </template>
    <RouterView v-slot="{ Component }">
      <KeepAlive include="'Relation'">
        <component :is="Component" />
      </KeepAlive>
    </RouterView>
  </AppLayout>
</template>
